export enum EStorage {
  APP_COUNTRY = 'APP_COUNTRY',
  APP_LANGUAGE = 'APP_LANGUAGE',
  APP_PERMISSIONS = 'APP_PERMISSIONS',
}



export default EStorage;
